<div class="gray-table" [class.gray-table--loading]="loading">
  <div *ngIf="responsive" class="table-responsive">
    <table
      class="table"
      [class.table-striped]="striped"
      [class.table-hover]="hover"
      [class.table-bordered]="bordered"
      [class.table-sm]="small"
    >
      <thead>
      <tr>
        <th
          *ngFor="let col of columns; trackBy: trackByIndex"
          [style.width]="col.width || null"
          [ngClass]="[getAlignClass(col.align), col.headerClass || '']"
          scope="col"
        >
          {{ col.header }}
        </th>
      </tr>
      </thead>

      <tbody>
      <tr *ngIf="loading">
        <td [attr.colspan]="columns.length">
          <div class="d-flex align-items-center gap-2 py-2">
            <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
            <span>Loading…</span>
          </div>
        </td>
      </tr>

      <tr *ngIf="!loading && (!data || data.length === 0)">
        <td [attr.colspan]="columns.length" class="text-muted py-3">
          {{ emptyText }}
        </td>
      </tr>

      <tr
        *ngFor="let row of data; trackBy: trackByIndex"
        (click)="onRowClick(row)"
        [class.gray-table__row-clickable]="clickableRows"
      >
        <td
          *ngFor="let col of columns; trackBy: trackByIndex"
          [ngClass]="[getAlignClass(col.align), getCellClass(col, row)]"
        >
          <ng-container *ngIf="getTemplate(col.key) as tpl; else textCell">
            <ng-container
              *ngTemplateOutlet="tpl; context: { $implicit: row, row: row, col: col }"
            ></ng-container>
          </ng-container>

          <ng-template #textCell>
            {{ getCellText(col, row) }}
          </ng-template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination footer (server-side) -->
  <div *ngIf="paginationEnabled" class="d-flex justify-content-between align-items-center py-2 gap-2">
    <div class="text-muted small">
      {{ rangeText }}
    </div>

    <div class="d-flex align-items-center gap-2">
      <div *ngIf="showPageSizeSelector" class="d-flex align-items-center gap-2">
        <span class="text-muted small">Sayfa başına kayıt</span>
        <select class="form-select form-select-sm gray-table__page-size"
                [value]="pageSize"
                (change)="onPageSizeChange($any($event.target).value)"
                [disabled]="loading">
          <option *ngFor="let ps of pageSizeOptions" [value]="ps">{{ ps }}</option>
        </select>
      </div>

      <div class="btn-group" role="group" aria-label="Pagination">
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="goToPage(1)" [disabled]="page <= 1 || loading">
          «
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="prevPage()" [disabled]="page <= 1 || loading">
          ‹
        </button>

        <button type="button" class="btn btn-sm btn-outline-secondary disabled">
          {{ page }} / {{ totalPages }}
        </button>

        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="nextPage()" [disabled]="page >= totalPages || loading">
          ›
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary"
                (click)="goToPage(totalPages)" [disabled]="page >= totalPages || loading">
          »
        </button>
      </div>
    </div>
  </div>
</div>
